import 'core-js/es6/map';
import 'core-js/es6/set';
import React from 'react';
import ReactDOM from 'react-dom';
import Application from "./presentation/Application";

ReactDOM.render(<Application />, document.getElementById('root'));